module.exports = __webpack_public_path__ + "static/img/user_action.05b53459.png";